import { render, staticRenderFns } from "./PagoByDesempenio.vue?vue&type=template&id=0a50b162"
import script from "./PagoByDesempenio.vue?vue&type=script&lang=js"
export * from "./PagoByDesempenio.vue?vue&type=script&lang=js"
import style0 from "./PagoByDesempenio.vue?vue&type=style&index=0&id=0a50b162&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports